// Single source of truth for the backend API base URL. REACT_APP_API_URL is
// baked into the compiled bundle at build time (Create React App inlines
// process.env.REACT_APP_* references). Production builds default to the
// current origin (nginx proxies /api to the backend on every vhost - :80,
// :443 via creativeelearning.com, and UAT :8080), so the same bundle works
// over http://IP, https://domain, or UAT without mixed-content blocks or
// cross-origin CORS concerns. The localhost fallback only ever applies to
// local development (`npm start` without the variable set).
export const API_URL = process.env.REACT_APP_API_URL
  || (process.env.NODE_ENV === 'production' ? window.location.origin : 'http://localhost:8000');
